module.exports = __webpack_public_path__ + "6855a08c0707fd087555341b672c4160.png";